import { compose, withProps } from 'recompose';
import { getConfigurationContext } from './../../provider/configuration/ConfigurationProvider';

const withConfiguration = (actions: { [key: string]: ({ }: object) => any }) =>
  compose(
    withProps(() => {
      const { dispatchConfiguration, config } = getConfigurationContext();
      let dispatchedActions = {};
      for (const actionName of Object.keys(actions)) {
        dispatchedActions = {
          [`${actionName}Config`]: actions[actionName]({ dispatchConfiguration }),
          ...dispatchedActions
        };
      }
      return {
        dispatchConfiguration,
        ...dispatchedActions,
        config
      };
    })
  );

export default withConfiguration;



// WEBPACK FOOTER //
// ./src/components/hoc/withConfiguration/withConfiguration.ts